import type { PropsWithChildren, ReactElement } from 'react'
import { formClass } from '~/components/Form/Form.css'

export const InputCol = ({ children }: PropsWithChildren): ReactElement => {
  return <div className={formClass}>{children}</div>
}
